var _path, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15053_8585",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 15,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50024 1.67651H16.7108V18.2211H2.50024V1.67651Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15053_8585)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31116 2.92651C4.93033 2.92651 3.78366 4.04485 3.75116 5.42401V14.3365C3.72033 15.764 4.84533 16.9398 6.25866 16.9715H12.9787C14.3695 16.914 15.4712 15.7582 15.4612 14.3415V6.94985L11.5987 2.92651H6.32116H6.31116ZM6.32116 18.2215H6.23033C4.12866 18.174 2.45533 16.4257 2.50116 14.3232V5.40901C2.5495 3.34151 4.257 1.67651 6.3095 1.67651H6.32366H11.8653C12.0353 1.67651 12.1978 1.74568 12.3162 1.86818L16.537 6.26568C16.6487 6.38151 16.7112 6.53735 16.7112 6.69818V14.3365C16.7262 16.4273 15.0978 18.1357 13.0037 18.2207L6.32116 18.2215Z",
    fill: "currentColor"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0821 7.48699H13.7862C12.2612 7.48283 11.0212 6.23949 11.0212 4.71616V2.29199C11.0212 1.94699 11.3012 1.66699 11.6462 1.66699C11.9912 1.66699 12.2712 1.94699 12.2712 2.29199V4.71616C12.2712 5.55283 12.9521 6.23449 13.7879 6.23699H16.0821C16.4271 6.23699 16.7071 6.51699 16.7071 6.86199C16.7071 7.20699 16.4271 7.48699 16.0821 7.48699",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4906 13.4238H6.99058C6.64558 13.4238 6.36558 13.1438 6.36558 12.7988C6.36558 12.4538 6.64558 12.1738 6.99058 12.1738H11.4906C11.8356 12.1738 12.1156 12.4538 12.1156 12.7988C12.1156 13.1438 11.8356 13.4238 11.4906 13.4238",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7865 10.2971H6.98983C6.64483 10.2971 6.36483 10.0171 6.36483 9.67212C6.36483 9.32712 6.64483 9.04712 6.98983 9.04712H9.7865C10.1315 9.04712 10.4115 9.32712 10.4115 9.67212C10.4115 10.0171 10.1315 10.2971 9.7865 10.2971",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.e58b4e66b3b3c2c6a85cf584c376894f.svg";
export { ForwardRef as ReactComponent };